module.exports = __webpack_public_path__ + "static/media/1-Klapp (1).8e2152fd.mp3";